import config from 'js-yaml-loader!../../../../config/packages/accord_responsive_image.yaml';

/**
 * @param {String} imageSetName
 * @return {Object}
 */
function findImageSet(imageSetName)
{
    let imageSet = find(config.accord_responsive_image.sets, (imageSet) => {
        return imageSet.name === imageSetName;
    });
    if(imageSet === undefined) throw 'Image set "' + imageSetName + '" not found';
    return imageSet;
}

function find(items, testFunction)
{
    let match = null;
    items.forEach((item) => {
        if(testFunction(item)) match = item;
    });
    return match;
}

/**
 * @param {String} imageSetName
 * @returns {null|Object}
 */
function findDefaultSize(imageSetName)
{
    let imageSet = findImageSet(imageSetName);
    // console.log(imageSet.sizes);
    return find(imageSet.sizes, (size) => {
        return size.default === true;
    });
}

function createSizesAttr(imageSetName)
{
    let parts = [];
    let imageSet = findImageSet(imageSetName);

    imageSet.sizes.forEach((size) => {
        let mediaQuery = size.media_queries.join(' and ');
        mediaQuery = translateMediaQuery(mediaQuery);
        parts.push(mediaQuery + ' ' + size.width + 'px');
    });

    return parts.join(', ');
}

function createSrcSetAttr(imageSetName, srcPath)
{
    let parts = [];
    let imageSet = findImageSet(imageSetName);
    imageSet.sizes.forEach((size) => {
        let path = resolvePath(imageSetName, size.width, srcPath);
        parts.push(path + ' ' + size.width + 'w');
    });
    return parts.join(', ');
}


function createDefaultSrcAttr(imageSetName, srcPath)
{
    let size = findDefaultSize(imageSetName);
    if(size === null) return null;
    return resolvePath(imageSetName, size.width, srcPath);
}

function findAliasedMediaQuery(name)
{
    let aliases = config.accord_responsive_image.media_query_aliases;
    if(aliases[name] === undefined) throw 'Media query alias "' + name + '" not defined';
    return aliases[name];
}

function translateMediaQuery(mediaQuery)
{
    return mediaQuery.replace(/@([a-z\-_]+)/ig, (fullMatch, name) => {
        return findAliasedMediaQuery(name);
    });
}

function resolvePath(imageSetName, width, srcPath)
{
    if(!srcPath) return '';
    if(srcPath[0] !== '/') srcPath = '/' + srcPath;
    return '/media/responsive/' + imageSetName + '-' + width + srcPath.replace(/ /g,"%20");
}

export default {
    //'createSizesAttr': createSizesAttr,
    'createSrcSetAttr': createSrcSetAttr,
    'findImageSet': findImageSet,
    'translateMediaQuery': translateMediaQuery,
    'resolvePath': resolvePath,
    'createDefaultSrcAttr': createDefaultSrcAttr
};
